import axios from "axios";

axios.defaults.headers.common["Accept"] = "application/json";
axios.defaults.headers.post["Content-Type"] = "application/json";
// axios.defaults.withCredentials = true;

// Set on explicit sign-out so the next sign-in shows the account picker
// instead of silently re-authenticating via the Office host
export const LSKEY_FORCEINTERACTIVELOGIN = "mm365-forceinteractivelogin";

const clientLog = (text: string) => {
  console.log("[MailMerge365] " + text);
  return text;
};

const serverLog = async (text: string) => {
  await serverPost("/api/log", { text });
};

const serverFilePost = async (url: string, data: any) => {
  return await axios.request({
    method: "post",
    url,
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const serverPost = async (url: string, payload: any) => {
  return await axios.request({
    method: "post",
    url,
    data: payload,
    withCredentials: true,
    responseType: "json",
    responseEncoding: "utf-8",
  });
};

const serverDelete = async (url: string, payload: any) => {
  return await axios.request({
    method: "delete",
    url,
    data: payload,
    withCredentials: true,
  });
};

const toQueryString = (obj) => {
  var parts = [];
  for (var i in obj) {
    if (obj.hasOwnProperty(i)) {
      parts.push(encodeURIComponent(i) + "=" + encodeURIComponent(obj[i]));
    }
  }
  return parts.join("&");
};

const serverGet = async (url: string, params: any) => {
  return await axios.request({
    url:
      url +
      "?" +
      toQueryString({
        ...params,
        ts: new Date().getTime(),
      }),
    withCredentials: true,
  });
};

const apiLink = async (
  pluginVersion: string,
  idJwt: string,
  restToken: string,
  restUrl: string,
  hostname: string,
  pluginEmail?: string
) => {
  var result = await serverPost("/api/link", {
    idJwt,
    restToken,
    restUrl,
    pluginVersion,
    hostname,
    pluginEmail,
  });

  return result.data;
};

const apiUnlink = async () => {
  await serverPost("/api/unlink", {});
};

const apiGetCampaign = async (exchangeItemID: string) => {
  var result = await serverGet("/api/campaign", {
    exchangeItemID,
  });

  return result.data;
};

const apiGetAccount = async () => {
  var result = await serverGet(`/api/account`, {});

  return result.data;
};

const apiCreateCampaign = async (
  exchangeItemID: string,
  name: string,
  cloneBodyAndSubjectFromCampaignID?: string,
  createSourceFromCampaignID?: string,
  createSourceFromCriteria?: string
) => {
  var result = await serverPost("/api/campaign", {
    exchangeItemID,
    name,
    cloneBodyAndSubjectFromCampaignID,
    createSourceFromCampaignID,
    createSourceFromCriteria,
  });

  return result.data;
};

const apiDeleteCampaign = async (campaignID: string) => {
  var result = await serverDelete(`/api/campaign/${campaignID}`, {});
  return result.data;
};

const apiSetCampaignSettings = async (campaignID: string, payload: any) => {
  var result = await serverPost(`/api/campaign/${campaignID}/settings`, {
    ...payload,
    campaignID,
  });

  return result.data;
};

const apiSetCampaignPreview = async (campaignID: string, payload: any) => {
  var result = await serverPost(`/api/campaign/${campaignID}/preview`, {
    ...payload,
    campaignID,
  });

  return result.data;
};

const apiUploadSourceData = async (campaignID: string, files: any) => {
  let formData = new FormData();
  formData.append("campaignID", campaignID);
  formData.append("files", files[0]);

  var result = await serverFilePost("/api/sourcedata", formData);
  return result.data;
};

const apiUploadSourceDataDirect = async (campaignID: string, data: string) => {
  let formData = new FormData();
  formData.append("campaignID", campaignID);
  formData.append("data", data);

  var result = await serverFilePost("/api/sourcedata/direct", formData);
  return result.data;
};

const apiCheckSourceData = async (campaignID: string) => {
  var result = await serverGet("/api/sourcedata", { campaignID });
  return result.data;
};

const apiContinueSourceData = async (campaignID: string) => {
  var result = await serverPost(
    "/api/sourcedata/continue?campaignID=" + campaignID,
    {}
  );
  return result.data;
};

export {
  clientLog,
  serverLog,
  serverPost,
  apiLink,
  apiUnlink,
  serverGet,
  apiGetCampaign,
  apiCreateCampaign,
  apiDeleteCampaign,
  apiUploadSourceData,
  apiUploadSourceDataDirect,
  apiContinueSourceData,
  apiCheckSourceData,
  apiSetCampaignSettings,
  apiGetAccount,
  apiSetCampaignPreview,
};


/* global window */

/**
 * Constructs a local URL for the web page for the given path.
 * @param path The path to construct a local URL for.
 * @returns
 */
export function createLocalUrl(path: string) {
    return `${window.location.origin}/${path}`;
}

// Injected by webpack DefinePlugin at build time
declare const BUILD_DATE: string;

export function getVersion() {
    return typeof BUILD_DATE !== "undefined" ? BUILD_DATE : "2026-06-10";
}